module.exports = __webpack_public_path__ + "media/vue/assets/images/qr-codes/hk_getapp-81bcb99d4b93a1d9799923f90c99e5fa.png";